/*import axios from 'axios';

const api = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
});

export default api;
*/

import axios from 'axios';

const api = axios.create({
  baseURL: '/',//'https://localhost:7214',
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
});

export default api;